import React, { Component, Fragment } from 'react'
import { Chat, HelpHeader, MainContainer, Separator, FBCommunityBanner, PrivacyMessage } from './customComponents'
import FICRestV2 from 'FICRestV2'
import FICPageSection, { FICPageSectionBlock } from 'FICPageSection'
import styled from 'styled-components'
import FICColors from 'FICColors'
import ContentLoader from 'react-content-loader'
import { FALIcon } from 'FAIcon'

export default class MainPage extends Component {
  constructor (props) {
    super(props)
    this.state = { loading: true, chat: {} }
    this.loadCategories()
  }

  renderLoadingBoxes = () => {
    let data = [ 1, 2, 3, 4, 5, 6 ]
    return data.map((content, idx) => {
      return (
        <Section key={idx}>
          <SectionLoading />
        </Section>)
    })
  }

  renderCategories = () => {
    return this.state.sections.map((content, idx) => {
      return (
        <Section key={idx} onClick={() => this.props.changeView(content.permalink, 'sezione')}>
          <SectionIcon name={content.icon} size={30} />
          <h2>{content.title}</h2>
          <p>{content.description}</p>
        </Section>
      )
    })
  }

  loadCategories = () => {
    FICRestV2.get({
      request: 'help/list',
      queryData: { realm: this.props.realm, is_dev: window.location.host.includes('-dev') ? 1 : 0 },
      onSuccess: (response) => {
        this.setState({ sections: response.data.sections, chat: response.data.chat, loading: false })
      }
    })
  }

  render () {
    return (
      <MainContainer className={this.props.className ? this.props.className : undefined}>
        {this.props.realm === 'fic' &&
        <FBCommunityBanner isExternal={this.props.isExternal} />
        }
        <HelpHeader
          closeIcon={!this.props.embedded}
          onClickClose={this.props.onClickClose}
          onSelect={this.props.changeView}
          className='helpHeader'
          isExternal={this.props.isExternal}
          realm={this.props.realm}
          embedded={this.props.embedded}
        />
        <SectionsBoxes>
          <FICPageSectionBlock>
            {this.state.loading ? this.renderLoadingBoxes() : this.renderCategories()}
          </FICPageSectionBlock>
        </SectionsBoxes>
        {this.state.chat.open && reactGlobalParams.chat.help_visible &&
        <Fragment>
          <Separator />
          <Chat warning={this.state.chat.warning} />
          <PrivacyMessage isFic={this.props.realm === 'fic'} />
        </Fragment>
        }
      </MainContainer>
    )
  }
}

const SectionsBoxes = styled(FICPageSection)`
	margin: 30px 0;
	.fic-page-section-block{
	  width: auto;
	  max-width: 840px;
	  @media all and (-ms-high-contrast: none) {
	    max-width: 945px;
	  }
	  margin: 0 auto;
	  display: flex;
	  @media screen and (max-width: 799px){
	    justify-content: center;  
	  }
	  flex-flow: row wrap;
	  justify-content: left;
	  &:after {
      content: "";
      flex: 0 0 255px;
      margin: 25px 12.5px 0;
    }
	}
`

const SectionImpl = ({ className, ...props }) => <div className={className} onClick={props.onClick}>{props.children}</div>

const Section = styled(SectionImpl)`
  height: auto;
  background-color: ${FICColors.white};
  border: 1px solid rgba(51,51,51,0.08);
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);
  flex: 0 0 255px;
  @media screen and (max-width: 560px){
    flex: 0 0 96%;
  }
  margin: 25px 12.5px 0;
  padding:16px;
  box-sizing: border-box;
  vertical-align: top;
  text-align: left;
  border-radius: 5px;
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out;
  &:hover{
    box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);
  }
  h2{
    font-size: 17px;
    font-weight: bold;
    line-height: 32px;
    margin-bottom: 5px;
    margin-top: 8px;
    @media (max-width: 425px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  p{
    color: rgba(51,51,51,0.64);
    font-size: 16px;
    line-height: 24px;
    @media (max-width: 425px) {
      font-size: 14px;
      line-height: 21px;
    }
  }
`

const SectionLoading = () => <ContentLoader
  height={170}
  width={256}
  speed={2}
  primaryColor='#f3f3f3'
  secondaryColor='#ecebeb'
>
  <rect x='16.03' y='101' rx='3' ry='3' width='210' height='6.4' />
  <rect x='16.03' y='122' rx='3' ry='3' width='228' height='6.4' />
  <rect x='16.03' y='142' rx='3' ry='3' width='120.6' height='6.4' />
  <circle cx='42' cy='34' r='30' />
  <rect x='16.14' y='76.61' rx='0' ry='0' width='158.87' height='13.02' />
</ContentLoader>

const SectionIconImpl = ({ className, ...props }) => <div className={className}>
  <FALIcon {...props} size={props.size} color='#0078CD' />
</div>

const SectionIcon = styled(SectionIconImpl)`
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: #D6E9F7;
  text-align: center;
  display: inline-table;
  .fa, .faicon{
    margin-top: 7px;
    font-size: 23px;
    color:#319be6; 
    display: table-cell;
    vertical-align: middle; 
  }
`



// WEBPACK FOOTER //
// ./src/help/common/MainPage.js